import React from 'react'
import { SvgIcon } from '@mui/material'

export const ContrastIcon = () => (
  <SvgIcon
    viewBox="0 0 16 16"
    sx={{ height: '16px', width: '16px', color: 'white' }}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.99992 1.3335C7.12444 1.3335 6.25753 1.50593 5.4487 1.84097C4.63986 2.176 3.90493 2.66706 3.28587 3.28612C2.03563 4.53636 1.33325 6.23205 1.33325 8.00016C1.33325 9.76827 2.03563 11.464 3.28587 12.7142C3.90493 13.3333 4.63986 13.8243 5.4487 14.1594C6.25753 14.4944 7.12444 14.6668 7.99992 14.6668C9.76803 14.6668 11.4637 13.9644 12.714 12.7142C13.9642 11.464 14.6666 9.76827 14.6666 8.00016C14.6666 7.12468 14.4941 6.25778 14.1591 5.44894C13.8241 4.6401 13.333 3.90517 12.714 3.28612C12.0949 2.66706 11.36 2.176 10.5511 1.84097C9.7423 1.50593 8.8754 1.3335 7.99992 1.3335ZM4.22659 11.7735C5.19325 12.7335 6.52659 13.3335 7.99992 13.3335C9.41441 13.3335 10.771 12.7716 11.7712 11.7714C12.7713 10.7712 13.3333 9.41465 13.3333 8.00016C13.3333 6.52683 12.7333 5.1935 11.7733 4.22683L4.22659 11.7735Z"
      fill="white"
    />
  </SvgIcon>
)
